import React, { useState, useEffect } from "react";
import { get } from "../../api/usersModule/httpClient";
import { useDebounce } from "../../hooks/useDebounce";
import { LargeCard } from "../Cards/LargeCard";
import { ModalReports } from "../Modals/ModalReports";
import { CDBModal } from "cdbreact";
import Swal from "sweetalert2";
import axios from "axios";

const usersheaders = [
  "Nº de lote",
  "Código SAP",
  "Descripción",
  "Código Proveedor",
  "Proveedor",
  "Factura",
  "Remisión",
  "Certificado de Calidad",
  "Hoja de seguridad",
  "% de documentos",
  "Fecha",
  "Acción",
  "Usuario",
];

const defaultFormData = {
  selectedOptions: [],
  TimeStart: "",
  TimeEnd: "",
  selectedUser: "",
  selectedCodeSap: "",
  selectedLote: "",
  selectedReceipt: "",
  selectedRemission: "",
  selectedQualityCertificate: "",
  selectedSafetySheet: "",
};

export const CrudDocManagementsRecord = ({ userName, project }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [pressedButton, setPressedButton] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [initialRender, setInitialRender] = useState(true);
  const [changePage, setChangePage] = useState(false);
  const [state, setState] = useState({ modal6: false });
  const [action, setAction] = useState("");
  const [skus, setSkus] = useState([]);
  const [receptions, setReceptions] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [providers, setProviders] = useState([]);

  const getData = async (search, statusPage) => {
    try {
      setLoading(true);
      const response = await get(
        `/documentsManagements?page=${statusPage}&search=${search}&Nit=${project}&documentsManagementsHistory=True&limit=${itemsPerPage}`
      );
      if (response && response.answer) {
        setTotalItems(response.pagination.totalItems);
        setData(response.items);
      } else {
        console.error("Error fetching data: Unexpected response format");
        setTotalItems(0);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire(
        "Error",
        "Error al obtener los datos. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
      setTotalItems(0);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const [formData, setFormData] = useState({
    ...defaultFormData,
    user: userName,
  });

  const getSku = async () => {
    try {
      const response = await get(`/skus?Nit=${project}&Lista=True`);
      if (response && response.items) {
        setSkus(response.items);
      } else {
        console.error("Error fetching SKU data: Unexpected response format");
        Swal.fire(
          "Error",
          "Hubo un error al obtener los datos de SKU. Por favor, inténtelo de nuevo más tarde.",
          "error"
        );
        setSkus([]);
      }
    } catch (error) {
      console.error("Error fetching SKU data:", error);
      Swal.fire(
        "Error",
        "Error al obtener los datos de SKU. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
      setSkus([]);
    }
  };

  const getReception = async () => {
    try {
      const response = await get(`/receptions?Nit=${project}&List=True`);
      if (response && response.items) {
        setReceptions(response.items);
      } else {
        console.error(
          "Error fetching reception data: Unexpected response format"
        );
        Swal.fire(
          "Error",
          "Hubo un error al obtener los datos de recepción. Por favor, inténtelo de nuevo más tarde.",
          "error"
        );
        setReceptions([]);
      }
    } catch (error) {
      console.error("Error fetching reception data:", error);
      Swal.fire(
        "Error",
        "Error al obtener los datos de recepción. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
      setReceptions([]);
    }
  };

  const getProviders = async () => {
    try {
      const response = await get(`/projects?Nit=${project}&list=${true}`);
      if (response && response.items) {
        setProviders(response.items);
      } else {
        console.error("Error fetching providers: No items found in response");
        setProviders([]);
      }
    } catch (error) {
      console.error("Error fetching providers:", error);
      setProviders([]);
      Swal.fire({
        title: "Error",
        text: "Error al obtener los proveedores. Por favor, inténtelo de nuevo más tarde.",
        icon: "error",
        confirmButtonColor: "#146284",
      });
    }
  };

  const toggle = (nr) => () => {
    let modalNumber = "modal" + nr;
    setState({ ...state, [modalNumber]: !state[modalNumber] });
  };

  const closeModal = () => {
    setState({ ...state, modal6: false });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const convertDataToArray = () => {
    try {
      return data.map((item) => {
        const counters = {
          Si: 0,
          No: 0,
          Registros: 0,
        };

        ["Receipt", "Remission", "QualityCertificate", "SafetySheet"].forEach(
          (key) => {
            if (item[key] === "Si") {
              counters.Si++;
              counters.Registros++;
            } else if (item[key] === "No") {
              counters.No++;
              counters.Registros++;
            }
          }
        );

        const porcentaje = ((counters.Si / counters.Registros) * 100).toFixed(
          2
        );

        return [
          item.LotNumber.toUpperCase(),
          item.CodeSap.toUpperCase(),
          item.SkuDescription.toUpperCase(),
          item.Nit.toUpperCase(),
          item.ProjectName.toUpperCase(),
          item.Receipt,
          item.Remission,
          item.QualityCertificate,
          item.SafetySheet,
          porcentaje + "%",
          item.HistorialDate,
          item.ActionCreate,
          item.User.split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" "),
        ];
      });
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const handleSubmit = () => {
    const requiredFields = formData.selectedOptions;

    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      Swal.fire({
        title: "Error!",
        text: "Por favor, rellene todos los campos",
        icon: "error",
        confirmButtonColor: "#146284",
      });
      setLoading(false);
      return false;
    }

    return true;
  };

  const documentGenerate = async () => {
    try {
      // Convertir TimeStart y TimeEnd a formato ISO solo con la fecha (sin horas)
      if (formData.TimeStart && formData.TimeEnd) {
        const timeStart = new Date(formData.TimeStart);
        const timeEnd = new Date(formData.TimeEnd);

        // Convertir las fechas a formato ISO (YYYY-MM-DD) sin horas
        formData.TimeStart = timeStart.toISOString().split("T")[0];
        formData.TimeEnd = timeEnd.toISOString().split("T")[0];
      }

      const response = await axios.get(
        `/documentsManagements?documentGenerate=${true}`,
        {
          params: formData,
        }
      );

      if (response.status === 200) {
        // Notificar al usuario que se inició la generación del reporte
        Swal.fire({
          title: "Generación Iniciada",
          text: "Se ha iniciado la generación del reporte. Te notificaremos cuando esté disponible.",
          icon: "success",
          confirmButtonColor: "#146284",
        });
      } else {
        // Mostrar mensaje de error genérico
        Swal.fire({
          title: "Error",
          text: "Error al generar el informe. Por favor, verifica la información.",
          icon: "error",
          confirmButtonColor: "#146284",
        });
      }
    } catch (error) {
      // Manejar error
      console.error("Error generando el informe:", error);
      Swal.fire({
        title: "Error",
        text: "Error al generar el informe. Por favor, verifica la información.",
        icon: "error",
        confirmButtonColor: "#146284",
      });
    }

    setFormData(defaultFormData);
  };

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    if (!changePage) {
      getData(debouncedSearch, page);
    } else {
      setChangePage(false);
    }
  }, [page, initialRender]);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [itemsPerPage]);

  useEffect(() => {
    switch (pressedButton.split(",")[0]) {
      case "submitModal":
        const success = handleSubmit();
        if (success) {
          documentGenerate();
          toggle(6)();
        }
        break;
      case "refresh":
        getData("", page);
        break;
      case "reports":
        getProviders();
        getSku();
        getReception();
        toggle(6)();
        break;
      case "closeModal":
        toggle(6)();
        break;
      default:
        break;
    }
    setPressedButton("");
  }, [pressedButton]);

  return (
    <>
      <LargeCard
        name={"Historial de gestión documental"}
        headers={usersheaders}
        loading={loading}
        data={convertDataToArray()}
        totalItems={totalItems}
        customTable={false}
        setPage={setPage}
        page={page}
        setChangePage={setChangePage}
        setPressedButton={setPressedButton}
        setSearch={setSearch}
        cState={false}
        reportState={true}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
      />
      <CDBModal isOpen={state.modal6} toggle={toggle(6)}>
        <ModalReports
          action={action}
          setPressedButton={setPressedButton}
          formData={formData}
          closeModal={closeModal}
          handleChange={handleChange}
          skus={skus}
          receptions={receptions}
          origin={"DOCUMENT"}
          providers={providers}
        />
      </CDBModal>
    </>
  );
};
